document.addEventListener('DOMContentLoaded', function() {

    // count number page agence
    var countElements = document.querySelectorAll('.js-count');
    countElements.forEach(function(element) {
        var startCount = 0;
        var endCount = parseInt(element.textContent);
        var duration = 5500;
        var startTime = null;

        function animateCount(timestamp) {
            if (!startTime) startTime = timestamp;
            var progress = timestamp - startTime;
            var percentage = Math.min(progress / duration, 1);
            var currentCount = Math.ceil((endCount - startCount) * percentage + startCount);
            element.textContent = currentCount;
            if (percentage < 1) {
                requestAnimationFrame(animateCount);
            }
        }

        requestAnimationFrame(animateCount);
    });



	// BOUTON SCROLLTOP
	var scrollToTopButton = document.getElementById("scroll-to-top");
	if (scrollToTopButton) {
		scrollToTopButton.addEventListener("click", function() {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: "smooth",
			});
		});
	}

    // Sélection du footer
    var footer = document.querySelector("footer");

    function checkScrollPosition() {
        if (!footer || !scrollToTopButton) return;

        var windowHeight = window.innerHeight;
        var scrollY = window.scrollY || window.pageYOffset;
        var footerOffsetTop = footer.offsetTop;

        var triggerOffset = 100; 

        if ((windowHeight + scrollY) >= (footerOffsetTop - triggerOffset)) {
            scrollToTopButton.style.opacity = "1";
            scrollToTopButton.style.pointerEvents = "auto";
        } else {
            scrollToTopButton.style.opacity = "0";
            scrollToTopButton.style.pointerEvents = "none";
        }
    }

    window.addEventListener("scroll", checkScrollPosition);
    checkScrollPosition();


    // FAQ
    const faqItems = document.querySelectorAll(".expertisestemplate_faq-bloc--item");

    faqItems.forEach((item) => {
        const content = item.querySelector(".content");

        // état initial fermé
        content.style.height = "0";
        content.style.paddingTop = "0";

        item.addEventListener("click", () => {
            item.classList.toggle("active");

            if (item.classList.contains("active")) {
                // recalcul dynamique de la hauteur
                const fullHeight = content.scrollHeight;
                content.style.paddingTop = "20px";
                content.style.height = fullHeight + "px";
            } else {
                content.style.paddingTop = "0";
                content.style.height = "0";
            }
        });
    });


    // Carrousel - Vérifier si les éléments existent avant d’appeler slick
    if (jQuery('.expertisestemplate_carrousel-img').length) {
        jQuery('.expertisestemplate_carrousel-img').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            speed: 800,
            adaptiveHeight: false,
            vertical: false,
            pauseOnHover: true,
            focusOnSelect: true,
            asNavFor: '.expertisestemplate_carrousel-title',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        autoplay: false,
                    }
                }
            ]
        });
    }

    if (jQuery('.expertisestemplate_carrousel-title').length) {
        jQuery('.expertisestemplate_carrousel-title').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            vertical: true,
            pauseOnHover: true,
            asNavFor: '.expertisestemplate_carrousel-img',
            dots: false,
            adaptiveHeight: true,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        autoplay: false,
                    }
                }
            ]
        });
    }

    
    // ➕ Ajout du code pour wrapper les tables
    document.querySelectorAll('.contenuLibre--item-colonnesTextes-item table').forEach(function(table) {
        // Vérifie si la table n'est pas déjà dans une div.table-responsive
        if (!table.parentElement.classList.contains('table-responsive')) {
        // Créer une div wrapper
        const wrapper = document.createElement('div');
        wrapper.className = 'table-responsive';

        // Insérer la div avant la table
        table.parentNode.insertBefore(wrapper, table);

        // Déplacer la table dans la div
        wrapper.appendChild(table);
        }
    });


    /*******************************************************/
    /* data-gtm */
    /*******************************************************/

    // Ajout des attributs data-gtm au lien LinkedIn header
    var parentDiv1 = document.querySelector('.js_data_clic_linkedin_header');
    if (parentDiv1) {
        var link = parentDiv1.querySelector('a');
        
        if (link) {
            link.setAttribute('data-gtm', 'clic_linkedin_header');
        }
    }

    // Ajout des attributs data-gtm au lien contact header
    var parentDiv2 = document.querySelector('.js_data_clic_contactez_nous_header');
    if (parentDiv2) {
        var link = parentDiv2.querySelector('a');
        
        if (link) {
            link.setAttribute('data-gtm', 'clic_contactez_nous_header');
        }
    }

    // Ajout des attributs data-gtm au lien prendre rdv menu
    var specialLinks = document.querySelectorAll('.main-menu-specialbloc');
    specialLinks.forEach(function(specialLink) {
        specialLink.setAttribute('data-gtm', 'clic_prendre_rdv_menu');
    });

    // Ajout des attributs data-gtm au message de confirmation formulaire contact
    var confirmationDiv = document.querySelector('.gform_confirmation_message_2');
    if (confirmationDiv) {
        confirmationDiv.setAttribute('data-gtm', 'clic_btn_envoyer_contact');
    }

    /*******************************************************/
    /* data-gtm FIN */
    /*******************************************************/


    /***************************************************/
    /* DATALAYER */
    /***************************************************/

    window.dataLayer = window.dataLayer || [];

    (function(){

        var FORM_ID = 1;
        var FIELD_INPUT_ID = 'input_1_1';

        // Bouton "OK" de la page 1 (next)
        document.addEventListener('click', function(e){
            var btn = e.target.closest('#gform_next_button_1_2');
            if(!btn) return;

            var input = document.getElementById(FIELD_INPUT_ID);
            var value = input ? (input.value || '').trim() : '';

            if(!value) return;

            window.dataLayer.push({
                event: 'c_soumission_form_accueil',
                gf_form_id: FORM_ID,
                gf_field_id: 1,
                gf_field_label: 'Que_souhaitez_vous_assurer',
                gf_value: value
            });
        }, true);
    })();

});
